// @need-translate
import {t} from '../../../common/getTranslations';
import {TicketTypeVo} from '../../../common/shared/api/nicolas/vo/TicketTypeVo.enum';

// 번역키가 적용 안된 부분들은 현 시점에 다국어 처리가 필요하지 않은 부분들이므로 기존 그대로 사용합니다.
export function getUsageSalesTicketType({
  ticketType,
  itemCount,
  qty,
}: {
  ticketType: TicketTypeVo;
  itemCount: number;
  qty: number;
}) {
  let text = '';
  switch (ticketType) {
    case TicketTypeVo.BuyNewCustomerGift:
      text = `${t('common_ticket_possession_new')} ${t('common_ticket_amount', {values: {value: itemCount}})}`;
      break;
    case TicketTypeVo.RentNewCustomerGift:
      text = `${t('common_ticket_rental_new')} ${t('common_ticket_amount', {values: {value: itemCount}})}`;
      break;
    case TicketTypeVo.BuyCashDiscountSingle:
    case TicketTypeVo.BuyCashSingle:
      text = t('common_ticket_possession_cash');
      break;
    case TicketTypeVo.BuySingle:
      text = t('common_ticket_possession_amount', {values: {value: itemCount}});
      break;
    case TicketTypeVo.BuyPackage:
      text = t('cash_history_possession_package_plural', {
        values: {value: itemCount},
      });
      break;
    case TicketTypeVo.BuyEvent:
      text = t('cash_history_possession_gift_plural', {
        values: {value: itemCount},
      });
      break;
    case TicketTypeVo.BuyCoupon:
      text = t('cash_history_possession_gift_plural', {
        values: {value: itemCount},
      });
      break;
    case TicketTypeVo.BuyWaitFree:
      text = `${t('common_ticket_possession_wuf')} ${t('common_ticket_amount', {values: {value: itemCount}})}`;
      break;
    /** @deprecated */
    case TicketTypeVo.BuyWaitFreePlus:
      text = t('cash_history_legendpass_possession_plural', {
        values: {value: itemCount},
      });
      break;
    case TicketTypeVo.BuyTodayGift:
      text = t('cash_history_possession_today_gift_plural', {
        values: {value: itemCount},
      });
      break;
    case TicketTypeVo.BuyGiftFree:
    case TicketTypeVo.BuyCampaign:
      text = `${t('common_ticket_possession_free')} ${t('common_ticket_amount', {values: {value: itemCount}})}`;
      break;
    case TicketTypeVo.BuyMoviePpv:
      text = t('cash_history_movie_possession_view');
      break;
    case TicketTypeVo.RentCashDiscountSingle:
    case TicketTypeVo.RentCashSingle:
      text = t('common_ticket_rental_cash');
      break;
    case TicketTypeVo.RentSingle:
      text = t('common_ticket_rental_amount', {values: {value: itemCount}});
      break;
    case TicketTypeVo.RentPackage:
      text = t('cash_history_rental_package_plural', {
        values: {value: itemCount},
      });
      break;
    case TicketTypeVo.RentEvent:
      text = t('cash_history_rental_gift_plural', {values: {value: itemCount}});
      break;
    case TicketTypeVo.RentCoupon:
      text = t('cash_history_rental_gift_coupon_plural', {
        values: {value: itemCount},
      });
      break;
    case TicketTypeVo.RentGiftFree:
    case TicketTypeVo.RentCampaign:
      text = `${t('common_ticket_rental_free')} ${t('common_ticket_amount', {values: {value: itemCount}})}`;
      break;
    case TicketTypeVo.RentWaitFree:
      text = t('cash_history_wuf_gift_plural', {values: {value: itemCount}});
      break;
    case TicketTypeVo.RentWaitFreePlus:
      text = `${t('common_ticket_rental_wuf')} ${t('common_ticket_amount', {values: {value: itemCount}})}`;
      break;
    case TicketTypeVo.RentTodayGift:
      text = t('cash_history_rental_today_gift_plural', {
        values: {value: itemCount},
      });
      break;
    case TicketTypeVo.RentMoviePpv:
      text = t('cash_history_movie_rental_view');
      break;
    case TicketTypeVo.WebSeries:
      text = t('cash_history_ongoing_veiw_plural', {
        values: {value: itemCount},
      });
      break;
    case TicketTypeVo.Premium:
      text = t('cash_history_premium');
      break;
    default:
      break;
  }
  return qty > 1 ? `${text} x ${qty}` : text;
}
